module.exports = __webpack_public_path__ + "ee3c4bc34435cf7d124ab0ab8bea284b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment/social-3.jpg
// module id = ./assets/images/payment/social-3.jpg
// module chunks = 0